import React from "react";
import { Button } from "../ui/button";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Bloque de descarga de Nivel 1 (Diagnóstico).
 */
export function N1DownloadBlock({ n1Doc, caseDoc, acting, onDownload }) {
  return (
    <div
      className={`border p-6 ${caseDoc?.variant_nivel1 === "auto" ? "border-amber-300 bg-amber-50/40" : "border-emerald-200 bg-emerald-50/40"}`}
      data-testid="n1-download-block"
    >
      <p
        className={`text-[11px] uppercase tracking-widest font-medium mb-2 ${caseDoc?.variant_nivel1 === "auto" ? "text-amber-800" : "text-emerald-800"}`}
      >
        Diagnóstico disponible {caseDoc?.variant_nivel1 === "auto" ? "(Sin revisión humana)" : ""}
      </p>
      <h3 className="font-serif text-xl text-gray-900 mb-2">
        {caseDoc?.variant_nivel1 === "auto"
          ? "Tu PDF fue generado automáticamente y está disponible"
          : "Tu PDF está aprobado para descarga"}
      </h3>
      <p className="text-sm text-gray-700 mb-4">
        {caseDoc?.variant_nivel1 === "auto" ? (
          <>
            Este Diagnóstico fue generado por IA <strong>sin revisión humana experta</strong>. Es
            un insumo de apoyo y no reemplaza el concepto de un abogado titulado.
            <span className="block mt-2 text-amber-900">
              La responsabilidad por el uso del contenido es exclusivamente del usuario.
            </span>
          </>
        ) : (
          <>
            La revisión humana fue completada por nuestro experto. Cada descarga queda registrada
            en el audit log junto al hash SHA-256 del documento.
          </>
        )}
      </p>
      <div className="flex flex-wrap gap-3 items-center">
        <Button
          onClick={onDownload}
          disabled={acting}
          className="rounded-sm h-11"
          data-testid="case-download-n1-button"
        >
          {acting
            ? "Descargando…"
            : n1Doc?.tipo === "diagnostico_n1_zip"
              ? "Descargar paquete Diagnóstico (ZIP)"
              : "Descargar PDF Diagnóstico"}
        </Button>
        <span
          className="text-xs text-gray-500 font-mono truncate max-w-[280px]"
          title={n1Doc.hash_sha256}
        >
          SHA-256 {n1Doc.hash_sha256?.slice(0, 16)}…
        </span>
      </div>
    </div>
  );
}
